import { MissingAudiosReportItem } from '@mi-front/core';
import { BtnLink, PaginatedTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../components/date/LDateTime';
import { TimezoneCtxProvider } from '@app/core/context/timezone.context';
import { ReportResultProps } from '../../../../../../../core/reports/types';
import { useStationsFinder } from '../../../../../../../core/stations/hooks/useStations';
import { GlobalMissingAudiosReport } from '../types';

import { FormattedMessage } from 'react-intl';
export function GlobalMissingAudiosReportResult(p: ReportResultProps<GlobalMissingAudiosReport>) {
  const { $t } = useIntl();
  const findStation = useStationsFinder();

  const showStation = p.values.groupBy.id !== 'none';

  const viewScheduleUrlFn = (item: MissingAudiosReportItem) =>
    `/audit/s/${item.stationId}/schedule/spot/${item.id}`;

  return (
    <TimezoneCtxProvider
      value={{
        timezone: p.values.timezone,
      }}
    >
      <PaginatedTable
        columns={[
          {
            Header: $t({
              id: 'common.station',
              defaultMessage: 'Emisora',
            }),
            accessor: (schedule) => findStation(schedule.stationId)?.name ?? schedule.stationId,
            w: 16,
            width: showStation ? undefined : 0,
          },
          {
            Header: $t({
              id: 'audit.props.customId',
              defaultMessage: 'ID material',
            }),
            accessor: (schedule) => schedule.customId,
            w: 16,
          },
          {
            Header: $t({
              id: 'audit.missingAudios.scheduleDatetime',
              defaultMessage: 'Fecha y hora programada',
            }),
            accessor: (schedule) => <LDateTime value={schedule.datetime} />,
            w: 25,
          },
          {
            Header: $t({
              id: 'audit.props.advertiser',
              defaultMessage: 'Anunciante',
            }),
            accessor: (schedule) => schedule.advertiser,
            w: 20,
          },
          {
            Header: $t({
              id: 'audit.props.version',
              defaultMessage: 'Versión',
            }),
            accessor: (schedule) => schedule.version,
            w: 20,
          },
          {
            Header: $t({
              id: 'common.text.actions',
              defaultMessage: 'Acciones',
            }),
            align: 'center',
            accessor: (schedule) => (
              <BtnLink
                size="xs"
                to={viewScheduleUrlFn(schedule)}
                openInNewTab
                icon={<OpenInNewIcon />}
                className="mr-2"
              >
                <FormattedMessage
                  id="audit.missingAudios.viewScheduleBtn"
                  defaultMessage="Ver detalle de entrada"
                />
              </BtnLink>
            ),
          },
        ]}
        data={p.result.items}
      />
    </TimezoneCtxProvider>
  );
}
